"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var IntermediateContextHolder_1 = __importDefault(require("./IntermediateContextHolder"));
var constants_1 = require("../constants");
var AnyValueCondition_1 = __importDefault(require("../types/resolverConditions/AnyValueCondition"));
var EqualResolverCondition_1 = __importDefault(require("../types/resolverConditions/EqualResolverCondition"));
var IntermediateResolverConditionBuilder = (function () {
    function IntermediateResolverConditionBuilder(variant, context) {
        if (context === void 0) { context = constants_1.EmptyContext; }
        this.variant = variant;
        this.contextHolder = new IntermediateContextHolder_1.default(context);
    }
    IntermediateResolverConditionBuilder.prototype.equal = function (value) {
        var currentCondition = new EqualResolverCondition_1.default(this.variant, value);
        return this.contextHolder.performPendingOperation(currentCondition);
    };
    IntermediateResolverConditionBuilder.prototype.any = function () {
        var values = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            values[_i] = arguments[_i];
        }
        var currentCondition = new AnyValueCondition_1.default(this.variant, values);
        return this.contextHolder.performPendingOperation(currentCondition);
    };
    return IntermediateResolverConditionBuilder;
}());
exports.default = IntermediateResolverConditionBuilder;
